import { grayColor, light_grey, light_grey_1, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const tableHeaderStyle = (theme) => ({
	searchIcon: {
		height: '16px',
		width: 'auto',
	},
	tableHeaderWrapper: {
		backgroundColor: whiteColor,
		borderTopLeftRadius: '8px',
		borderTopRightRadius: '8px',
		padding: '0 16px',
		display: 'flex',
		alignItems: 'flex-end',
		minHeight: '50px',
		[theme.breakpoints.down('xs')]: {
			flexWrap: 'wrap',
		},
	},
	searchWrapper: {
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
		'& .MuiFormControl-root ': {
			marginBottom: '15px',
		},
	},
	downloadWrapper: {
		marginLeft: '16px',
		marginBottom: '2px',
		[theme.breakpoints.down('xs')]: {
			marginLeft: 0,
			marginBottom: 6,
		},
	},
	wrapper: {
		display: 'block',
		marginRight: 0,
		marginLeft: 'auto',
	},
	alignCenter: {
		alignItems: 'center',
	},
	withText: {
		[theme.breakpoints.down('xs')]: {
			paddingTop: '10px',
			flexDirection: 'column',
			alignItems: 'flex-end',
			'& > p': {
				width: '100%',
			},
		},
	},
	headerButtonsWrapper: {
		display: 'flex',
		marginRight: 0,
		marginLeft: 'auto',
	},
	withStroke: {
		borderLeft: `solid 1px rgba(0, 0, 0, 0.12)`,
		borderTop: `solid 1px rgba(0, 0, 0, 0.12)`,
		borderRight: `solid 1px rgba(0, 0, 0, 0.12)`,
	},
	searchBackground: {
		'& .MuiInputBase-root': {
			padding: '12px 16px 12px 16px',
			width: '309px',
			background: light_grey,
			borderBottom: `1px solid ${light_grey_1}`,
		},
	},
	searchIconLarge: {
		height: '34px',
		width: 'auto',
	},
});

export default tableHeaderStyle;
